export const PREFIX = process.env.PREFIX || '';
